module.exports = __webpack_public_path__ + "img/qr_not_active1.8f857ada.svg";